<div class="term-of-use">
  <h2 class="semi-bold mb-4">Terms & conditions</h2>
  <div class="d-flex flex-column term-of-use-container">
    <ds-checkbox
      class="read-and-accept"
      (selectedChange)="selectReadAndAccept.emit($event)"
      [selected]="readAndAccept"
      [state]="readAndAcceptError ? 'error' : 'default'"
      inputId="read-and-accept"
      data-id="read-and-accept"
    >
      <div>
        <div
          [innerHtml]="disclaimersHtml || ''"
          class="disclaimers scrollable"
          data-id="disclaimers-html"
        ></div>

        <div
          [innerHtml]="disclaimersCheckmarkHtml || ''"
          class="mt-3 disclaimers"
          data-id="disclaimers-checkmark-html"
        ></div>
      </div>
    </ds-checkbox>

    <div class="d-flex align-items-center mt-3">
      <img src="assets/icons/lock_green.svg" width="20" height="20" alt="lock" class="mb-auto" />

      <p class="ml-2 caption text-green-700 semi-bold">
        We use secure transmission to protect your personal information.
      </p>
    </div>
  </div>
</div>
